module.exports = __webpack_public_path__ + "img/Journalism06.5e6681ca.png";